import { faGear } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { RAGFLOW_BASE_URL } from 'constants/env';
import Detail from 'containers/desktop/KnowledgeBases/components/Detail';
import Overview from 'containers/desktop/KnowledgeBases/components/Overview';
import useState from 'containers/desktop/KnowledgeBases/useState';

const KnowledgeBases = () => {
	const { classes, cx } = useStyles();
	const { state, handlers } = useState();
	const { t } = useTranslation();

	useEffect(() => {
		handlers.initialize();
	}, []);

	return (
		<div className={cx(classes.container, 'container')}>
			<div className={classes.header}>
				<h1>{t('admin:KNOWLEDGE_BASE')}</h1>
				<a className="btn btn-primary" target="_blank" href={RAGFLOW_BASE_URL}>
					<FontAwesomeIcon icon={faGear} className={classes.icon} />
					{t('admin:CONFIGURATION')}
				</a>
			</div>
			<hr />
			<RenderIf condition={!state.currentKnowledgeBaseId}>
				<Overview state={state} handlers={handlers} />
			</RenderIf>
			<RenderIf condition={Boolean(state.currentKnowledgeBaseId)}>
				<Detail state={state} handlers={handlers} />
			</RenderIf>
		</div>
	);
};

export default KnowledgeBases;

export const useStyles = tss.create({
	container: {
		height: '100%',
		padding: '20px 10px',
		display: 'flex',
		flexDirection: 'column',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	icon: {
		marginRight: '10px',
	},
});
